import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import AutoComplete from 'material-ui/AutoComplete';
import AppModel from '../DataModel/AppModel';

export default
@observer class SelectCustomer extends Component {

  handleUpdateInput(inputStr) {
    console.log(inputStr);
    this.props.targetForm.customer_search_text = inputStr;
  }

  handleSelection(selected) {
    console.log(selected);
    let customer = selected.value
    let form = this.props.targetForm;
    form.customer= customer;
    setTimeout(()=>{
      form.customer_search_text = customer.name;
    },1);
    if(this.props.onSelectionChanged) {
      this.props.onSelectionChanged();
    }
  }

  render() {
    let form = this.props.targetForm
    let showSelf = this.props.showSelf || false;
    return (
      <AutoComplete floatingLabelText={uiMsg('CS_SELECT_CUST',"Select customer")}
                    searchText={form.customer_search_text}
                    fullWidth={true}
                    hintText={uiMsg('CS_HINT_TEXT',"Start typing name of customer")}
                    openOnFocus={true}
                    onUpdateInput={this.handleUpdateInput.bind(this)}
                    onNewRequest={this.handleSelection.bind(this)}
                    filter={AutoComplete.fuzzyFilter}
                    dataSource={showSelf ?
                       AppModel.customerSelectListWithOwnCompany
                      :AppModel.customerSelectList}
      />
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SelectCustomer.jsx
 **/